export default __webpack_public_path__ + "static/media/bayer.43e3921f.svg";